import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  jointInitiative: {
    id: 'portal.components.footer.jointInitiative',
    defaultMessage: 'a joint initiative of',
    description: 'Footer joint initiative text under the logo',
  },
  theProgramme: {
    id: 'portal.components.footer.theProgramme.link.text',
    defaultMessage: 'The Programme',
    description: 'Footer The Programme link text',
  },
  about: {
    id: 'portal.components.footer.about.link.text',
    defaultMessage: 'About',
    description: 'Footer About link text',
  },
  modules: {
    id: 'portal.components.footer.modules.link.text',
    defaultMessage: 'Modules',
    description: 'Footer Modules link text',
  },
  login: {
    id: 'portal.components.footer.login.link.text',
    defaultMessage: 'Login',
    description: 'Footer Login link text',
  },
  broughtToYouBy: {
    id: 'portal.components.footer.broughtToYouBy.link.text',
    defaultMessage: 'Brought to you by',
    description: 'Footer Brought to you by link text',
  },
  legatum: {
    id: 'portal.components.footer.legatum.link.text',
    defaultMessage: 'Legatum',
    description: 'Footer Legatum link text',
  },
  oxfordCharacterProject: {
    id: 'portal.components.footer.oxfordCharacterProject.link.text',
    defaultMessage: 'Oxford Character Project',
    description: 'Footer Oxford Character Project link text',
  },
  humanFlourishing: {
    id: 'portal.components.footer.humanFlourishing.link.text',
    defaultMessage: 'The Human Flourishing {lineBreak} Program at Harvard',
    description: 'Footer Human Flourishing Program link text',
  },
  support: {
    id: 'portal.components.footer.support.link.text',
    defaultMessage: 'Support',
    description: 'Footer Support link text',
  },
  contact: {
    id: 'portal.components.footer.contact.link.text',
    defaultMessage: 'Contact',
    description: 'Footer Contact link text',
  },
  privacyPolicy: {
    id: 'portal.components.footer.privacyPolicy.link.text',
    defaultMessage: 'Privacy Policy',
    description: 'Footer Privacy Policy link text',
  },
  termsOfUse: {
    id: 'portal.components.footer.termsOfUse.link.text',
    defaultMessage: 'Terms of Use',
    description: 'Footer Terms of Use link text',
  },
  copyright: {
    id: 'portal.components.footer.copyright',
    defaultMessage: 'Copyright © {year} Legatum LTD. All rights reserved.',
    description: 'Footer copyright text',
  },
  trademark: {
    id: 'portal.components.footer.trademark',
    defaultMessage: '"Look within, lead beyond" is a trademark of Heart to Heart Leadership. It is used with permission.',
    description: 'Footer trademark text',
  },
});

export default messages;
